import { useMemo } from "react";
import { BillingInfo, PriceItem, CancelSurvey, ref } from ".";
import * as InMemoryStorage from "./in-memory-storage";
import useGlobalContex from "../utils/global-context/hook";

export const usePersistentStorage = () => {
	const context = useGlobalContex();

	useMemo(() => {
		ref(context).setPriceItem(PriceItem);
		ref(context).setBillingInfo(BillingInfo);
		ref(context).setCancelSurvey(CancelSurvey);
	}, [context]);
};

export const useInMemoryStorage = () => {
	const context = useGlobalContex();

	useMemo(() => {
		ref(context).setPriceItem(InMemoryStorage.PriceItem);
		ref(context).setBillingInfo(InMemoryStorage.BillingInfo);
		ref(context).setCancelSurvey(InMemoryStorage.CancelSurvey);
	}, [context]);
};
